import { render } from "./login-2.vue?vue&type=template&id=627eed4a&scoped=true"
import script from "./login-2.vue?vue&type=script&lang=js"
export * from "./login-2.vue?vue&type=script&lang=js"

import "./login-2.vue?vue&type=style&index=0&id=627eed4a&lang=scss&scoped=true"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627eed4a"]])

export default __exports__